import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { JournalVoucherTable } from "./JournalVoucherTable";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { isValidForm } from "../../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import { permission } from "../../../utils/enums/ValidationMessage";

class JournalVoucher extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            urlId: 0,
            prop: {},
            table2Data: [],
            table2ColDefs: [],
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            rowData: [],
            colDefs: [],
            idCompany: 0,
            idUser: 0,
            idJournalVoucher: 0,
            journalVoucherDetails: {
                idJournalVoucher: 0,
                updateStatus: 0,
                voucherNo: "",
                date: "",
                //accSubHead: [],
                //selectParty: [],
                //selectSecParty: [],
                //employee: [],
                //fromAccount: [],
                //fromAccountType: [],
                //selectSeries: [],
                //chequeNo: [],
                chequeDate: "",
                refNo: "",

                taxType: [],
                taxGroup: [],


                // new
                aCCSubHeadList: [],
                mainACCSubHeadList: [],
                idGeneralProduct: 0,
                productName: "",
                bankList: [],
                mainBankList: [],
                idBank: 0,
                bankName: "",
                partyList: [],
                mainPartyList: [],
                idPartyAccount: "",
                partyACName: "",
                //partyList2: [],
                //mainPartyList2: [],
                //idPartyAccount2: "",
                //partyACName2: "",
                employeeList: [],
                mainEmployeeList: [],
                idEmployee: 0,
                employeeName: "",
                types: [
                    {
                        id: 1,
                        name: "CREDIT",
                    },
                    {
                        id: 2,
                        name: "DEBIT",
                    }
                ],
                seriesList: [],
                mainSeriesList: [],
                idChequeBookMaster: 0,
                chequeBookSeries: "",
                // idChequeBookDetails: [],
                chequeNoList: [],
                mainChequeNoList: [],
                idChequeBookDetails: 0,
                chequeNo: "",
                taxtStructureList: [],
                mainTaxStructureList: [],
                idTaxStructure: 0,
                taxStructureName: "",
                taxtTypeList: [
                    {
                        id: 1,
                        name: 'INTRASTATE'
                    },
                    {
                        id: 2,
                        name: 'INTERSTATE'
                    }
                ],
                idTaxtType: 1,
                taxtTypeName: "INTRASTATE",
                cgst: "",
                cgstAmt: 0,
                sgst: "",
                sgstAmt: 0,
                igst: "",
                igstAmt: 0,
                amount: 0,
                netTotal: "",
                remarks: "",
                e_Date: "",
                updatedDate: "",
                idFinancialYear: 0,
                expenseBy: [
                    {
                        id: 1,
                        name: "Party",
                    },
                    {
                        id: 2,
                        name: "Employee",
                    },
                    {
                        id: 3,
                        name: "Bank",
                    },
                    {
                        id: 4,
                        name: "Acc. sub head",
                    }
                ],
                expenseById1: 0,
                expenseByName1: "",
                partyList1: [],
                forSerarchPartyList1: [],
                idPartyAccount1: 0,
                partyACName1: "",
                expenseById2: 0,
                expenseByName2: "",
                partyList2: [],
                forSerarchPartyList2: [],
                idPartyAccount2: 0,
                partyACName2: "",
                fromAccountTypeId1: 2,
                fromAccountTypeName1: "DEBIT",
                fromAccountTypeId2: 2,
                fromAccountTypeName2: "CREDIT",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                idPartyAccount1: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party"
                        ),
                    },
                ],
                idPartyAccount2: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "second party"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                // idTaxStructure: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.SelectRequired.replace(
                //             "{0}",
                //             "tax group"
                //         ),
                //     },
                // ],
            },
        };
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Journal Voucher");
        //}
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_GeneralProductSelect();
            });
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
        setTimeout(() => {
            //this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };

    getJournalVoucherSelectbyID = () => {
        this.accountTransactionServices.getJournalVoucherSelectbyID(this.state.idJournalVoucher).then((response) => {
            // if (response.statusCode !== 200 || !response.responseItem) {
            //     this.setState({ isModalOpen: true });
            //     return;
            // }

            let journalVoucherResponse = response.responseItem.responseContent?.[0] || {};
            let journalVoucher = { ...this.state.journalVoucherDetails };

            journalVoucher.idJournalVoucher = journalVoucherResponse.idJournalVoucher || "";
            journalVoucher.updateStatus = 1;
            journalVoucher.voucherNo = journalVoucherResponse.voucherNo || "";
            journalVoucher.date = journalVoucherResponse.voucherDate ? moment(journalVoucherResponse.voucherDate).format('YYYY-MM-DD') : "";
            journalVoucher.chequeDate = journalVoucherResponse.chequeDate ? moment(journalVoucherResponse.chequeDate).format('YYYY-MM-DD') : "";
            journalVoucher.refNo = journalVoucherResponse.referenceNo || "";
            journalVoucher.amount = journalVoucherResponse.amount || "";
            journalVoucher.netTotal = journalVoucherResponse.netTotal || "";
            journalVoucher.remarks = journalVoucherResponse.remarks || "";
            journalVoucher.e_Date = journalVoucherResponse.e_Date || "";
            journalVoucher.updatedDate = 1;
            journalVoucher.idFinancialYear = journalVoucherResponse.idFinancialYear || "";

            let bankRequest = { idBank: journalVoucherResponse.idPartyAccount || 0, updateStatus: 1 };
            let chequeBookRequest = {
                idChequeBookMaster: journalVoucherResponse.idChequeBookMaster || 0,
                updateStatus: 1,
                idChequeBookDetails: journalVoucherResponse.idChequeBookDetails || 0,
            };

            let ExpenseByRequest1 = {
                idCompany: this.state.idCompany,
                expenseById: journalVoucherResponse.expenseById1,
            };
            let ExpenseByRequest2 = {
                idCompany: this.state.idCompany,
                expenseById: journalVoucherResponse.expenseById2,
            };

            this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(bankRequest).then((res) => {
                if (journalVoucherResponse.expenseById1 === (journalVoucher.expenseBy?.find(item => item.name === "Bank")?.id)) {
                    journalVoucher.seriesList = (res.statusCode === 200 && res.responseItem)
                        ? res.responseItem.responseContent.map((x) => ({
                            id: x.idChequeBookMaster,
                            name: x.chequeBookSeries || "",
                        }))
                        : [];
                    journalVoucher.mainSeriesList = journalVoucher.seriesList;
                }

                this.accountTransactionServices.getChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher(chequeBookRequest).then((chequeNo) => {
                    journalVoucher.chequeNoList = (chequeNo.statusCode === 200 && chequeNo.responseItem)
                        ? chequeNo.responseItem.responseContent.map((x) => ({
                            id: x.idChequeBookDetails,
                            name: x.chequeNo || "",
                        }))
                        : [];
                    journalVoucher.mainChequeNoList = journalVoucher.chequeNoList;

                    this.accountTransactionServices.getSelectedExpenseByList(ExpenseByRequest1).then((partyList1) => {
                        journalVoucher.partyList1 = (partyList1.statusCode === 200 && partyList1.responseItem)
                            ? partyList1.responseItem.responseContent
                            : [];
                        journalVoucher.forSerarchPartyList1 = journalVoucher.partyList1;

                        this.accountTransactionServices.getSelectedExpenseByList(ExpenseByRequest2).then((partyList2) => {
                            journalVoucher.partyList2 = (partyList2.statusCode === 200 && partyList2.responseItem)
                                ? partyList2.responseItem.responseContent
                                : [];
                            journalVoucher.forSerarchPartyList2 = journalVoucher.partyList2;

                            if (journalVoucherResponse.idTaxGroup !== undefined || journalVoucherResponse.idTaxGroup !== null) {
                                this.accountTransactionServices.getTaxStructureSelectbyID(journalVoucherResponse.idTaxGroup).then((taxRes) => {
                                    if (taxRes.statusCode === 200 && taxRes.responseItem) {
                                        let taxData = taxRes.responseItem.responseContent?.[0] || {};
                                        journalVoucher.sgst = taxData.sgst || "";
                                        journalVoucher.cgst = taxData.cgst || "";
                                        journalVoucher.igst = taxData.igst || "";
                                    }

                                    journalVoucher.idGeneralProduct = journalVoucherResponse.idAccountHead || "";
                                    journalVoucher.productName = journalVoucherResponse.idAccountHead
                                        ? journalVoucher.aCCSubHeadList?.find(item => item.id === journalVoucherResponse.idAccountHead)?.name || ""
                                        : "";

                                    journalVoucher.idBank = journalVoucherResponse.fromAC || "";
                                    journalVoucher.bankName = journalVoucherResponse.fromAC
                                        ? journalVoucher.bankList?.find(item => item.id === journalVoucherResponse.fromAC)?.name || ""
                                        : "";

                                    journalVoucher.idPartyAccount1 = journalVoucherResponse.idPartyAccount || "";
                                    journalVoucher.partyACName1 = journalVoucherResponse.idPartyAccount
                                        ? journalVoucher.forSerarchPartyList1?.find(item => item.id === journalVoucherResponse.idPartyAccount)?.name || ""
                                        : "";

                                    journalVoucher.expenseById1 = journalVoucherResponse.expenseById1 || "";
                                    journalVoucher.expenseByName1 = journalVoucherResponse.expenseById1
                                        ? journalVoucher.expenseBy?.find(item => item.id === journalVoucherResponse.expenseById1)?.name || ""
                                        : "";

                                    journalVoucher.idPartyAccount2 = journalVoucherResponse.idPartyAccount2 || "";
                                    journalVoucher.partyACName2 = journalVoucherResponse.idPartyAccount2
                                        ? journalVoucher.forSerarchPartyList2?.find(item => item.id === journalVoucherResponse.idPartyAccount2)?.name || ""
                                        : "";

                                    journalVoucher.expenseById2 = journalVoucherResponse.expenseById2 || "";
                                    journalVoucher.expenseByName2 = journalVoucherResponse.expenseById2
                                        ? journalVoucher.expenseBy?.find(item => item.id === journalVoucherResponse.expenseById2)?.name || ""
                                        : "";

                                    journalVoucher.idEmployee = journalVoucherResponse.idEmployee || "";
                                    journalVoucher.employeeName = journalVoucherResponse.idEmployee
                                        ? journalVoucher.employeeList?.find(item => item.id === journalVoucherResponse.idEmployee)?.name || ""
                                        : "";

                                    journalVoucher.idChequeBookMaster = journalVoucherResponse.idChequeBookMaster || "";
                                    journalVoucher.chequeBookSeries = journalVoucherResponse.idChequeBookMaster
                                        ? journalVoucher.mainSeriesList?.find(item => item.id === journalVoucherResponse.idChequeBookMaster)?.name || ""
                                        : "";

                                    journalVoucher.idChequeBookDetails = journalVoucherResponse.idChequeBookDetails || "";
                                    journalVoucher.chequeNo = journalVoucherResponse.idChequeBookDetails
                                        ? journalVoucher.mainChequeNoList?.find(item => item.id === journalVoucherResponse.idChequeBookDetails)?.name || ""
                                        : "";

                                    journalVoucher.idTaxStructure = journalVoucherResponse.idTaxGroup || "";
                                    journalVoucher.taxStructureName = journalVoucherResponse.idTaxGroup
                                        ? journalVoucher.mainTaxStructureList?.find(item => item.id === journalVoucherResponse.idTaxGroup)?.name || ""
                                        : "";

                                    journalVoucher.cgstAmt = journalVoucherResponse.cgstAmt || "";
                                    journalVoucher.sgstAmt = journalVoucherResponse.sgstAmt || "";
                                    journalVoucher.igstAmt = journalVoucherResponse.igstAmt || "";

                                    journalVoucher.fromAccountTypeName1 = journalVoucherResponse.typeName1 || "DEBIT";
                                    journalVoucher.fromAccountTypeId1 = journalVoucherResponse.typeName1
                                        ? journalVoucher.types?.find(item => item.name === journalVoucherResponse.typeName1)?.id || 2
                                        : 2;

                                    journalVoucher.fromAccountTypeName2 = journalVoucherResponse.typeName2 || "CREDIT";
                                    journalVoucher.fromAccountTypeId2 = journalVoucherResponse.typeName2
                                        ? journalVoucher.types?.find(item => item.name === journalVoucherResponse.typeName2)?.id || 1
                                        : 1;

                                    this.setState({
                                        journalVoucherDetails: journalVoucher,
                                        isModalOpen: true,
                                    });

                                });
                            }
                        });
                    });
                });
            });
        });
    };


    getJournalVoucherCOUNT = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 0
        };
        this.accountTransactionServices.getJournalVoucherCOUNT(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let list = this.state.rowData;
                let maxIdPaymentMake = list.length > 0
                    ? Math.max(...list.map(item => item.idJournalVoucher))
                    : 0;
                let transferNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                let data = this.state.journalVoucherDetails;
                data.voucherNo = transferNo;
                this.setState({
                    journalVoucherDetails: data
                }, () => {
                    //this.usp_Master_GeneralProductSelect();
                });
            } else {
                //this.usp_Master_GeneralProductSelect();
            }
        });
    }

    usp_Master_GeneralProductSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                console.log(data);
                data = data.map((x) => ({
                    id: x.idGeneralProduct,
                    name: x.productName,
                }));
                let detail = this.state.journalVoucherDetails;
                detail.aCCSubHeadList = data;
                detail.mainACCSubHeadList = data;
                this.setState({
                    journalVoucherDetails: detail
                }, () => {
                    this.usp_Master_BankSelect();
                }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay();
                    }
                });
            } else {
                this.usp_Master_BankSelect();
            }
        });
    }

    usp_Master_BankSelect = () => {
        this.accountTransactionServices.usp_Master_BankSelect(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idBank,
                    name: x.bankName,
                }));
                let journalVoucher = this.state.journalVoucherDetails;
                journalVoucher.bankList = dynamicData;
                journalVoucher.mainBankList = dynamicData;
                this.setState({
                    journalVoucherDetails: journalVoucher
                }, () => {
                    //this.usp_Master_PartyAccountSelect();
                    this.getTaxStructure();
                });
            } else {
                //this.usp_Master_PartyAccountSelect();
                this.getTaxStructure();
            }
        });
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        id: x.idPartyAccount,
                        name: x.partyACName,
                    }));

                    let journalVoucher = this.state.journalVoucherDetails;
                    //journalVoucher.partyList = dynamicData;
                    //journalVoucher.mainPartyList = dynamicData;
                    //journalVoucher.partyList2 = dynamicData;
                    //journalVoucher.mainPartyList2 = dynamicData;
                    this.setState({
                        journalVoucherDetails: journalVoucher
                    }, () => {
                        this.usp_Master_EmployeeSelect();
                    });
                } else {
                    this.usp_Master_EmployeeSelect();
                }
            }
        });
    }

    usp_Master_EmployeeSelect = () => {
        this.accountTransactionServices.usp_Master_EmployeeSelect_WithNewChanges(this.state.idCompany).then((response) => {
            // debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idEmployee,
                    name: x.employeeName,
                    idGeneralProduct: x.idGeneralProduct
                }));
                let journalVoucherDetail = this.state.journalVoucherDetails;
                journalVoucherDetail.employeeList = data;
                journalVoucherDetail.mainEmployeeList = data;
                this.setState({
                    journalVoucherDetails: journalVoucherDetail
                }, () => {
                    this.getTaxStructure();
                });
            } else {
                this.getTaxStructure();
            }
        });
    }

    getTaxStructure = () => {
        this.accountTransactionServices.getTaxStructure(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                res = res.map((x) => ({
                    id: x.idTaxStructure,
                    name: x.taxStructureName,
                }));
                let journalVoucherDetail = this.state.journalVoucherDetails;
                journalVoucherDetail.taxtStructureList = res;
                journalVoucherDetail.mainTaxStructureList = res;
                this.setState({ journalVoucherDetails: journalVoucherDetail }, () => {
                    //this.getGatePass()
                })
                //this.getGatePass();
            }
        });
        //this.getGatePass();
    }

    getChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher = (idChequeBookMaster, updateStatus, idChequeBookDetails) => {
        let request = {
            idChequeBookMaster: idChequeBookMaster,
            updateStatus: updateStatus,
            idChequeBookDetails: idChequeBookDetails,
        };
        this.accountTransactionServices.getChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idChequeBookDetails,
                    name: x.chequeNo,
                }));
                let journalVoucherDetail = this.state.journalVoucherDetails;
                journalVoucherDetail.chequeNoList = data;
                journalVoucherDetail.mainChequeNoList = data;
                this.setState({
                    journalVoucherDetails: journalVoucherDetail
                });
            }
        });
    }

    usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake = (id, updateStatus) => {
        let request = {
            idBank: id,
            updateStatus: updateStatus,
            //idPaymentMake : this.state.journalVoucherDetails.idPaymentMake,
        };
        this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idChequeBookMaster,
                    name: x.chequeBookSeries,
                }));
                let journalVoucherDetail = this.state.journalVoucherDetails;
                journalVoucherDetail.seriesList = data;
                journalVoucherDetail.mainSeriesList = data;
                this.setState({
                    journalVoucherDetails: journalVoucherDetail
                });
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Journal Voucher",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key,
                            headerName: key,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            minWidth: this.getColumnWidth(key),
                            pinned: ["voucherNo", "voucherDate"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            hide: ["sR.No", "idJournalVoucher", "netTotal"].includes(key) ? true : false,
                            valueFormatter: key.includes("voucherDate") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Journal Voucher",
                            colName: colName
                        }, () => {
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Journal Voucher");
                            this.getJournalVoucherCOUNT();
                        }, () => {
                            if (this.gridApi) {
                                this.gridApi.hideOverlay();
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const columnWidths = {
            "fromAcType": window.innerWidth * 0.06,
            "toAcType": window.innerWidth * 0.06,
            "firstParty": window.innerWidth * 0.23,
            "secondParty": window.innerWidth * 0.23,
            "status": window.innerWidth * 0.08,
            "netTotal": window.innerWidth * 0.07,
            "amount": window.innerWidth * 0.07,
        };
        return columnWidths[key];
    };
    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "voucherNo": window.innerWidth * 0.055,
            "voucherDate": window.innerWidth * 0.07,
            "accSubHead": window.innerWidth * 0.14,
        }
        return pinnedWidths[key];
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        });
                    }
                }
            });
        }
    }

    openPopUpFromURLId = (id) => {
        this.setState({ idJournalVoucher: id }, () => {
            this.getJournalVoucherSelectbyID();
        });
    };

    getTaxStructureSelectbyID = (id) => {
        this.accountTransactionServices.getTaxStructureSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                //debugger;
                let data = this.state.journalVoucherDetails;
                data.sgst = res.sgst;
                data.cgst = res.cgst;
                data.igst = res.igst;
                //data.taxStructureName = data.taxGroupList?.find(item => item.id === data.idTaxStructure)?.name;
                ///data.unitDescription = data.unitList?.find(item => item.id === data.idUnit)?.name;
                this.setState({ journalVoucherDetails: data }, () => {
                    this.calculatePricing()
                });
            }
        });
    }

    calculatePricing = () => {
        let journalVoucherDetail = this.state.journalVoucherDetails;
        if (this.state.journalVoucherDetails.amount > 0) {
            journalVoucherDetail.sgstAmt = journalVoucherDetail.taxtTypeName === "INTRASTATE" ? Number(journalVoucherDetail.amount) * Number(journalVoucherDetail.sgst) / 100 : 0;
            journalVoucherDetail.cgstAmt = journalVoucherDetail.taxtTypeName === "INTRASTATE" ? Number(journalVoucherDetail.amount) * Number(journalVoucherDetail.cgst) / 100 : 0;
            journalVoucherDetail.igstAmt = journalVoucherDetail.taxtTypeName === "INTRASTATE" ? 0 : Number(journalVoucherDetail.amount) * Number(journalVoucherDetail.igst) / 100;

            journalVoucherDetail.netTotal = (Number(journalVoucherDetail.amount) + journalVoucherDetail.sgstAmt + journalVoucherDetail.cgstAmt + journalVoucherDetail.igstAmt);

            this.setState({
                journalVoucherDetails: journalVoucherDetail
            })
        } else {
            journalVoucherDetail.sgstAmt = 0;
            journalVoucherDetail.cgstAmt = 0;
            journalVoucherDetail.igstAmt = 0;

            journalVoucherDetail.netTotal = 0;

            this.setState({
                journalVoucherDetails: journalVoucherDetail
            })
        }
    }

    setFilterParameters = (id, name, drpIdentity) => {
        //debugger
        let data = this.state.journalVoucherDetails;
        if (drpIdentity === 'aCCSubHeadList') {
            data.idGeneralProduct = id;
            data.productName = name;
        }
        if (drpIdentity === 'SelectAccount1') {
            data.expenseById1 = id;
            data.expenseByName1 = name;
            if (id !== (data.expenseBy?.find(item => item.name === "Bank")?.id)) {
                data.idChequeBookMaster = 0;
                data.chequeBookSeries = "";
                data.idChequeBookDetails = 0;
                data.chequeNo = "";
                //data.typeId = 0;
                //data.typeName = "";
                //this.setState({
                data.seriesList = [];
                data.mainSeriesList = [];
                data.chequeNoList = [];
                data.mainChequeNoList = [];
                //types: []
                //});
            }
        }
        if (drpIdentity === 'partyList1') {
            data.idPartyAccount1 = id;
            data.partyACName1 = name;
        }
        if (drpIdentity === 'SelectAccount2') {
            data.expenseById2 = id;
            data.expenseByName2 = name;
        }
        if (drpIdentity === 'partyList2') {
            data.idPartyAccount2 = id;
            data.partyACName2 = name;
        }
        if (drpIdentity === 'FromAccount') {
            data.idBank = id;
            data.bankName = name;
            // data.idChequeBookMaster = 0;
            // data.chequeBookSeries = "";
            // data.seriesList = [];
            // data.idChequeBookDetails = 0;
            // data.chequeNo = "";
            // data.chequeNoList = [];
        }
        if (drpIdentity === 'selectBank') {
            data.idBank = id;
            data.bankName = name;
        }
        if (drpIdentity === 'selectSeries') {
            data.idChequeBookMaster = id;
            data.chequeBookSeries = name;
            data.idChequeBookDetails = 0;
            data.chequeNo = "";
            data.chequeNoList = [];
        }
        if (drpIdentity === 'chequeNo') {
            data.idChequeBookDetails = id;
            data.chequeNo = name;
        }
        if (drpIdentity === 'employeeList') {
            data.idEmployee = id;
            data.employeeName = name;
        }
        if (drpIdentity === 'TaxtStructureList') {
            data.idTaxStructure = id;
            data.taxStructureName = name;
        }
        // if (drpIdentity === 'Type') {
        //     data.fromAccountTypeId = id;
        //     data.fromAccountTypeName = name;
        // }
        this.setState({ journalVoucherDetails: data }, () => {
            if (drpIdentity === 'partyList1') {
                if (this.state.journalVoucherDetails.expenseById1 === (this.state.journalVoucherDetails.expenseBy?.find(item => item.name === "Bank")?.id)) {
                    this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(id, this.state.journalVoucherDetails.updateStatus);
                }
            } else if (drpIdentity === 'selectSeries') {
                this.getChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher(id, this.state.journalVoucherDetails.updateStatus, this.state.journalVoucherDetails.idJournalVoucher)
            } else if (drpIdentity === 'TaxtStructureList') {
                this.getTaxStructureSelectbyID(id);
            } else if (drpIdentity === 'SelectAccount1' || drpIdentity === 'SelectAccount2') {
                this.getSelectedExpenseByList(id, drpIdentity);
            }
        });
    };

    getSelectedExpenseByList = (id, drpIdentity) => {
        let request = {
            idCompany: this.state.idCompany,
            expenseById: id
        }
        this.accountTransactionServices.getSelectedExpenseByList(request).then((response) => {
            //debugger
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                // data = data.map((x) => ({
                //     id: x.idBank,
                //     name: x.bankName,
                // }));
                let journalVoucherDetail = this.state.journalVoucherDetails;
                if (drpIdentity === 'SelectAccount1') {
                    journalVoucherDetail.idPartyAccount1 = 0;
                    journalVoucherDetail.partyACName1 = "";
                    journalVoucherDetail.partyList1 = data;
                    journalVoucherDetail.forSerarchPartyList1 = data;
                } else {
                    journalVoucherDetail.idPartyAccount2 = 0;
                    journalVoucherDetail.partyACName2 = "";
                    journalVoucherDetail.partyList2 = data;
                    journalVoucherDetail.forSerarchPartyList2 = data;
                }
                this.setState({
                    journalVoucherDetails: journalVoucherDetail,
                    //mainBankList: data,
                    //ledgerDetails: ledgerDetail
                });
            }
        });
    }

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ idJournalVoucher: event.data.idJournalVoucher, validState: validState }, () => {
            this.getJournalVoucherSelectbyID();
        });
    };

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetFields();
        //this.procSelectAllRecordsSP();
        this.setState({ isModalOpen: true }, () => {
            this.getJournalVoucherCOUNT();
        })
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.journalVoucherDetails;
        details[name] = value;
        this.setState({ journalVoucherDetails: details }, () => {
            if (name === 'amount') {
                this.calculatePricing();
            }
        });
    }
    handleSelectChange = (event, name) => {
        let data = this.state.journalVoucherDetails;
        if (name === "aCCSubHeadList") {
            // debugger
            let arr = this.state.journalVoucherDetails.mainACCSubHeadList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            data.productName = value;
            data.aCCSubHeadList = found;

        } else if (name === 'FromAccount') {
            //debugger
            let arr = [...this.state.journalVoucherDetails.mainBankList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.journalVoucherDetails;
            data.bankName = value;
            data.bankList = found;
        } else if (name === "employeeList") {
            // debugger
            let arr = this.state.journalVoucherDetails.mainEmployeeList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.journalVoucherDetails;
            data.employeeName = value;
            data.employeeList = found;
        } else if (name === "TaxtStructureList") {
            // debugger
            let arr = this.state.journalVoucherDetails.mainTaxStructureList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.journalVoucherDetails;
            data.taxStructureName = value;
            data.taxtStructureList = found;
        } else if (name === 'selectSeries') {
            //debugger
            let arr = [...this.state.journalVoucherDetails.mainSeriesList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.journalVoucherDetails;
            data.chequeBookSeries = value;
            data.seriesList = found;
        } else if (name === 'chequeNo') {
            //debugger
            let arr = this.state.journalVoucherDetails.mainChequeNoList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            data.chequeNo = value;
            data.chequeNoList = found;
        } else if (name === 'partyList1') {
            //debugger
            let arr = this.state.journalVoucherDetails.forSerarchPartyList1;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.journalVoucherDetails;
            data.partyACName1 = value;
            data.partyList1 = found;
        } else if (name === 'partyList2') {
            //debugger
            let arr = this.state.journalVoucherDetails.forSerarchPartyList2;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.journalVoucherDetails;
            data.partyACName2 = value;
            data.partyList2 = found;
        }
        this.setState({ journalVoucherDetails: data });
    }

    submitJournalVoucher = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.journalVoucherDetails;
            let request = {
                idJournalVoucher: details.idJournalVoucher,
                updateStatus: details.updateStatus,
                voucherNo: details.voucherNo,
                voucherDate: details.date,
                idAccountHead: details.idGeneralProduct,
                idBank: 0, // details.idBank ,
                type: 0, //details.type ,
                fromAC: details.idBank,
                fromACType: "0", //details.bankName,
                chequeNo: details.chequeNo,
                chequeDate: details.date,
                referenceNo: details.refNo,
                amount: details.amount,
                idTaxGroup: details.idTaxStructure,
                sgstAmt: details.sgstAmt,
                cgstAmt: details.cgstAmt,
                igstAmt: details.igstAmt,
                netTotal: details.netTotal,
                remarks: details.remarks,
                idCompany: this.state.idCompany,
                e_Date: details.updateStatus > 0 ? details.e_Date : new Date().toISOString(),
                e_IDUser: this.state.idUser,
                isUpdated: details.updateStatus > 0 ? true : false,
                updatedDate: details.updateStatus > 0 ? new Date().toISOString() : details.updatedDate,
                u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                isDeleted: 0,
                deletedDate: null,
                d_IDUser: null,
                idChequeBookMaster: details.idChequeBookMaster,
                idChequeBookDetails: details.idChequeBookDetails,
                dbIdChecque: details.idChequeBookDetails,
                //idPartyAccount: details.idPartyAccount,
                //idPartyAccount2: details.idPartyAccount2,
                idEmployee: details.idEmployee,
                idFinancialYear: details.idFinancialYear,
                // new changes
                expenseById1: details.expenseById1,
                //expenseByName1: "",
                //partyList1: [],
                //forSerarchPartyList1: [],
                idPartyAccount1: details.idPartyAccount1,
                //partyACName1: "",
                expenseById2: details.expenseById2,
                //expenseByName2: "",
                //partyList2: [],
                //forSerarchPartyList2: [],
                idPartyAccount2: details.idPartyAccount2,
                //partyACName2: "",
                //fromAccountTypeId1: 2,
                fromAccountTypeName1: details.fromAccountTypeName1,
                //fromAccountTypeId2: 2,
                fromAccountTypeName2: details.fromAccountTypeName2,
            };
            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.accountTransactionServices.submitJournalVoucher(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    if (data !== null) {
                        if (this.state.journalVoucherDetails.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.setState({
                                isModalOpen: false,
                                //receiptDetails: reset
                            }, () => {
                                this.resetFields();
                                this.procSelectAllRecordsSP();
                            });
                        }
                    }
                }
            }).finally(() => {
                this.isSubmitting = false;
                this.setState({ isSaving: false });
            });
            // } else {
            //     console.log(this.state.journalVoucherDetails)
            //     console.log(this.state.validState.error)
            // }
            // this.setState({ isModalOpen: !this.state.isModalOpen });
        }
    }

    resetFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let reset = this.state.journalVoucherDetails;
        reset.idJournalVoucher = 0;
        reset.updateStatus = 0;
        reset.voucherNo = "";
        reset.date = "";
        reset.chequeDate = "";
        reset.refNo = "";
        reset.idGeneralProduct = 0;
        reset.productName = "";
        reset.idBank = 0;
        reset.bankName = "";
        reset.idPartyAccount = "";
        reset.partyACName = "";
        reset.idPartyAccount2 = "";
        reset.partyACName2 = "";
        reset.idEmployee = 0;
        reset.employeeName = "";
        reset.fromAccountTypeId1 = 2;
        reset.fromAccountTypeName1 = "DEBIT";
        reset.fromAccountTypeId2 = 1;
        reset.fromAccountTypeName2 = "CREDIT";
        reset.idChequeBookMaster = 0;
        reset.chequeBookSeries = "";
        reset.idChequeBookDetails = 0;
        reset.chequeNo = "";
        reset.idTaxStructure = 0;
        reset.taxStructureName = "";
        reset.idTaxtType = 1;
        reset.taxtTypeName = "INTRASTATE";
        reset.cgst = "";
        reset.cgstAmt = 0;
        reset.sgst = "";
        reset.sgstAmt = 0;
        reset.igst = "";
        reset.igstAmt = 0;
        reset.amount = 0;
        reset.netTotal = "";
        reset.remarks = "";
        reset.e_Date = "";
        reset.updatedDate = "";

        reset.expenseById1 = 0;
        reset.expenseByName1 = "";
        reset.partyList1 = [];
        reset.forSerarchPartyList1 = [];
        reset.idPartyAccount1 = 0;
        reset.partyACName1 = "";
        reset.expenseById2 = 0;
        reset.expenseByName2 = "";
        reset.partyList2 = [];
        reset.forSerarchPartyList2 = [];
        reset.idPartyAccount2 = 0;
        reset.partyACName2 = "";
        reset.fromAccountTypeId1 = 2;
        reset.fromAccountTypeName1 = "DEBIT";
        reset.fromAccountTypeId2 = 2;
        reset.fromAccountTypeName2 = "CREDIT";
        this.setState({ journalVoucherDetails: reset, validState: validState });
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.journalVoucherDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='journal-voucher'>
                <div className="data-display">
                    <div className="data-display-inner relative">
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: this.handleSave,
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <JournalVoucherTable
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            handleSelectChange={this.handleSelectChange.bind(this)}
                            journalVoucherDetails={this.state.journalVoucherDetails}
                            submitJournalVoucher={this.submitJournalVoucher.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            close={this.closePopup.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Journal Voucher</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                        {/* <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={table2Data}
                                    columnDefs={table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.state.onGridReady}
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default JournalVoucher;